import { useSnapshot } from 'valtio'
import React, { type ReactElement, useEffect } from 'react'
import { SlideOver } from '../../../../../../shared/components/ui/SlideOver'
import { GtagEvents, gtmTrackButtonPress } from '../../../../../../shared/utils/gtmUtils'
import { recurringPaymentEditProxy, resetRecurringPaymentEditProxy } from './recurringPaymentEditProxy'
import { RecurringConfigurationEditSlideContents } from './RecurringConfigurationEditSlideContents'
import { handleSubmitForRecurringConfigurationUpdate } from './utils'

const cancelFunction = (): void => {
  recurringPaymentEditProxy.displaySlideOver = false
  gtmTrackButtonPress(GtagEvents.CARD_MODAL_CANCEL)

  resetRecurringPaymentEditProxy()
}
export function RecurringConfigurationEditSlideOver (): ReactElement {
  const { displaySlideOver, allowSubmit } = useSnapshot(recurringPaymentEditProxy)
  useEffect(() => resetRecurringPaymentEditProxy, [])
  return (
    <SlideOver
      submitText="Save Changes"
      canSubmit={allowSubmit}
      isOpen={displaySlideOver}
      title="Edit Recurring Details"
      cancelFunction={cancelFunction}
      submitFunction={handleSubmitForRecurringConfigurationUpdate}
    >

      <RecurringConfigurationEditSlideContents />
    </SlideOver>
  )
}
